import React, { useState } from "react";
import HelpText from "./HelpText";
import {HelpTextData} from "../ISR/Pages/DefineModel/model";
import AppSettings from "../../../Settings/AppSettings";
import {useISRContext} from "../ISR/Hooks/useISRContext";
import Dialog from "Components/DesignSystem/Dialog/Dialog";

type TFieldProps = {
    selectedItemId?: string | null | undefined
    savedHelpTextData?: HelpTextData | null | undefined
    onDelete: () => void;
    onClose: () => void;
    onSubmit: (helpTextData: HelpTextData) => void;
}

/**
 * The Help Text popup shell, on DS Dialog (§ 84) — the legacy fixed overlay had
 * no Escape, no scrim-close and no close button; Cancel was the only exit. All
 * three now route through the same `onClose`. The footer buttons stay INSIDE
 * `HelpText` (not Dialog's `footer` slot) because ISR's `AdditionalData`
 * renders `HelpText` inline without any dialog around it.
 */
const HelpTextDialog = ({selectedItemId, savedHelpTextData, onDelete, onClose, onSubmit}: TFieldProps) => {
    const isrContext = useISRContext();
    /* The Dialog footer band is a slot; HelpText owns the editor state its Save
       needs, so it PORTALS its action row into this element (§ 84). A callback
       ref in state, so the portal re-renders once the node exists. */
    const [footerEl, setFooterEl] = useState<HTMLElement | null>(null);

    return (
        <Dialog isOpen onClose={onClose} title="Help Text" size="lg" data-testid="list-helptext-dialog"
                footer={<div ref={setFooterEl} className="tw-w-full" />}>
            {/* The double slash after GMS_BACKEND_API_URL is pinned legacy behavior
                (okf/list/e2e.md § 7.1) — servers normalize it; do not "fix" it here. */}
            <HelpText id='list-help-text' savedHelpTextData={savedHelpTextData} selectedItemId={selectedItemId}
                      attachmentUrl={`${AppSettings.GMS_BACKEND_API_URL}/industry/${isrContext?.industryId ?? ''}/list/${selectedItemId}/image/upload`}
                      onDelete={onDelete} onClose={onClose}
                      onSubmit={(helpTextData) => onSubmit(helpTextData)}
                      actionsContainer={footerEl}/>
        </Dialog>
    );
}

export default HelpTextDialog;
